import { BaseRequest } from 'planning-portal-library/src/lib/data/shared/base.request';
import { Observable } from "rxjs";
import { DistributionArea } from "../domain";

export abstract class DistributionAreaRepository {
    
    abstract getDistributionAreas(distributionLaneId: string): Observable<DistributionArea[]>;

}